import script from "./CustomerDistributionEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerDistributionEdit.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerDistributionEdit.vue?vue&type=style&index=0&id=eb9b7616&lang=scss"

const __exports__ = script;

export default __exports__